export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/sch_worker.289c6c03.worker.js");
}
